import React from 'react';
import './App.scss';
import { BrowserRouter } from "react-router-dom";
import { Layout } from "./layout/Layout";
import {Router} from "./app/router";
import {ToastContainer} from 'react-toastify';
import { GlobalContextProvider } from "./global-context";

function App() {
  return (
    <BrowserRouter>
      <ToastContainer style={{ zIndex: 1000 }}/>
      <GlobalContextProvider>
        <Layout>
          <Router />
        </Layout>
      </GlobalContextProvider>
    </BrowserRouter>
  );
}

export default App;
